import { CLOSE_UPGRADE_MODAL, OPEN_UPGRADE_MODAL } from "./actions";

const initialState = {
  isOpen: false,
};

function upgradeReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_UPGRADE_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case CLOSE_UPGRADE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}

export default upgradeReducer;
